import { render, staticRenderFns } from "./NotFoundPage404.vue?vue&type=template&id=32b039cf"
import script from "./NotFoundPage404.vue?vue&type=script&lang=js"
export * from "./NotFoundPage404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports